function List({ children }) {
  return (
    <div className="flex flex-col gap-2 min-h-24">
      {children}
    </div>
  );
}

export default List;